import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { tap } from "rxjs/operators";
import { AuthService } from "../service/auth.service";

@Injectable({
    providedIn: "root"
})
export class RoleGuard implements CanActivate {
    constructor(private authService: AuthService, public router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const tokenPayload = this.authService.getDecodedToken();

        if (!tokenPayload) {
            this.logout(state.url);
            return false;
        }

        if (!this.authService.isAuthenticated()) {
            this.logout(state.url);
            return false;
        }

        return true;
    }

    private logout = (originalUrl: string): void => {
        this.authService
            .logout()
            .pipe(
                tap(() => {
                    this.router.navigate(["/auth"], {
                        queryParams: { callbackUrl: originalUrl }
                    });
                })
            )
            .subscribe();
    };
}
